const getUserIp = async () => {
    try {
        const response = await fetch('https://api.ipify.org?format=json')
        const data = await response.json()
        return data.ip
    } catch (error) {
        console.error('Error al obtener la IP:', error)
        return null
    }
}
const getUserCountry = async (ipAddress) => {
    if (!ipAddress) return
    try {
        //const response = await fetch(`https://ip-api.com/json/${ipAddress}`) // Puedes usar otras APIs como ipinfo.io o ipdata.co
        const response = await fetch(`https://api.ipstack.com/${ipAddress}?access_key=4b926cd52fac2c799fdc27a2b6333a93`)
        const data = await response.json()
        if(!data?.country_code) console.error(data)
        return data?.country_code ? data : null
        // También puedes acceder a otros datos como data.city, data.timezone, etc.
    } catch (error) {
        console.error('Error al obtener la información de geolocalización:', error)
        return null
    }
}
const setCurrencyByCountry = (country_code = null) => {
    const inputCountryCode = document.querySelectorAll('#localization_formtoolbar input[name="country_code"]')
    if(!country_code || !inputCountryCode?.length) return
    inputCountryCode[0].value = country_code
    localStorage.setItem('jmCurrencySelected', country_code)
    document.getElementById('localization_formtoolbar')?.submit()
}
const isLocalTest = () => {
    const page_location = window.location.href
    const matchesException = ['chrome-error://chromewebdata/', '//localhost', '127.0.0.1']
    const matchesFound = matchesException?.filter(item => page_location?.includes(item))
    return matchesFound?.length
}
const evalCountryLoaded = async () => {
    let userCountry = null
    if(localStorage.getItem('jmCurrencySelected') || isLocalTest()) return
    if(localStorage.getItem('jmUserCountry')) {
        userCountry = JSON.parse(localStorage.getItem('jmUserCountry'))
        setCurrencyByCountry(userCountry?.country_code)
        return
    }
    const userIp = await getUserIp()
    userCountry = userIp ? await getUserCountry(userIp) : null
    localStorage.setItem('jmUserCountry', JSON.stringify(userCountry))
    setCurrencyByCountry(userCountry?.country_code)
}
const evalPageCustom = () => {
    const noVisiblePage = document.querySelectorAll('.no-visible-page')
    noVisiblePage?.forEach( page => {
        const blockSection = page.closest('section.shopify-section')
        blockSection?.classList?.add('no-visible-page-container')
    })
}
const handleize = (str = '') => {
    if (!str) return "";
    str = str.replace('á', 'a').replace('à', 'a').replace('ä', 'a').replace('â', 'a').replace('Á', 'A').replace('À', 'A').replace('Â', 'A').replace('Ä', 'A').replace('ª', 'a').replace('å', 'a').replace('æ', 'ae');
    str = str.replace('é', 'e').replace('è', 'e').replace('ë', 'e').replace('ê', 'e').replace('É', 'E').replace('È', 'E').replace('Ê', 'E').replace('Ë', 'E');
    str = str.replace('í', 'i').replace('ì', 'i').replace('ï', 'i').replace('î', 'i').replace('Í', 'I').replace('Ì', 'I').replace('Ï', 'I').replace('Î', 'I');
    str = str.replace('ó', 'o').replace('ò', 'o').replace('ö', 'o').replace('ô', 'o').replace('Ó', 'O').replace('Ò', 'O').replace('Ö', 'O').replace('Ô', 'O').replace('ø', 'o');
    str = str.replace('ú', 'u').replace('ù', 'u').replace('ü', 'u').replace('û', 'u').replace('Ú', 'U').replace('Ù', 'U').replace('Û', 'U').replace('Ü', 'U');
    str = str.replace('ñ', 'n').replace('Ñ', 'n');
    str = str.toLowerCase();

    var toReplace = ['"', "'", "\\", "(", ")", "[", "]"];

    // For the old browsers
    for (var i = 0; i < toReplace.length; ++i) {
    str = str.replace(toReplace[i], "");
    }
    str = str.replace(/\W+/g, "-");
    if (str.charAt(str.length - 1) == "-")
    str = str.replace(/-+\z/, "");

    if (str.charAt(0) == "-")
    str = str.replace(/\A-+/, "");

    return str;
}
const configureAditionalTagFilters = () => {
    //const special_collection = '/collections/goalkeeper-gloves'
    const blackListCollection = ['/collections/protective-gear-equipment', '/collections/protective-gear', '/collections/accessories']
    const page_location = window.location.href
    //if(!page_location?.includes(special_collection)) return
    if(!page_location?.includes('/collections/')) return
    if(blackListCollection?.some(item => page_location?.includes(item))) return
    
    let special_collection = null
    const collectionArray = window.location.pathname?.split('/')
    if(!(collectionArray?.length >= 3 && collectionArray[1] === 'collections')) return
    special_collection = '/collections/' + collectionArray[2]

    const filterFormDrawer = document.getElementById("FilterDrawer")?.querySelector(".filter-form")
    if(!filterFormDrawer) return

    const tags_string_1 = data_aditional_filter?.tags_string_1?.split('\n')
    const tags_string_2 = data_aditional_filter?.tags_string_2?.split('\n')
    const tags_string_3 = data_aditional_filter?.tags_string_3?.split('\n')
    const tags_string_4 = data_aditional_filter?.tags_string_4?.split('\n')
    const tags_string_5 = data_aditional_filter?.tags_string_5?.split('\n')
    const tags_string_6 = data_aditional_filter?.tags_string_6?.split('\n')

    //tags_string_1?.sort()
    //tags_string_2?.sort()
    //tags_string_3?.sort()
    //tags_string_4?.sort()
    //tags_string_5?.sort()
    //tags_string_6?.sort()

    const arrayFilters = [
        {
            title: 'PALM', 
            options: tags_string_1?.length ? tags_string_1 : []
        }, 
        {
            title: 'CUT', 
            options: tags_string_2?.length ? tags_string_2 : []
        }, 
        {
            title: 'BACKHAND', 
            options: tags_string_3?.length ? tags_string_3 : []
        }, 
        {
            title: 'FINGER SUPPORT', 
            options: tags_string_4?.length ? tags_string_4 : []
        }, 
        {
            title: 'SIZES', 
            options: tags_string_5?.length ? tags_string_5 : []
        }, 
        {
            title: 'COLOR', 
            options: tags_string_6?.length ? tags_string_6 : []
        }
    ]

    //SI YA EXISTE FILTRO EN LA URL
    const current_pathname = window.location.pathname
    let current_tags = current_pathname?.replace(special_collection, '')
    current_tags = current_tags?.replace('/', '')?.trim()
    if(current_tags !== '') {
        const arrayTags = current_tags?.split('+')
        const buttonDrawer = document.querySelector('.js-drawer-open-collection-filters > .current-tag-numbers')
        const currents = document.querySelectorAll('ul.tag-list--active-tags > li:not(.custom-filter-active)')
        const total_tags = arrayTags?.length + currents?.length
        if(buttonDrawer) {
            buttonDrawer.innerHTML = `(${total_tags})`
        } else {
            document.querySelector('.js-drawer-open-collection-filters')?.insertAdjacentHTML("beforeend", `<span class="current-tag-numbers" style="margin-left:5px">(${total_tags})</span>`)
        }
        document.querySelector('.js-drawer-open-collection-filters')?.classList?.add('btn--tertiary-active')

        let tagsParaListar = []
        const tags_listados = document.querySelectorAll('ul.tag-list--active-tags > li.custom-filter-active')
        if(tags_listados?.length) {
            tags_listados?.forEach( tag => {
                if(!arrayTags?.includes(tag?.getAttribute('data-value'))) {
                    tagsParaListar?.push(tag)
                }
            })
        } else {
            tagsParaListar = arrayTags
        }

        if(tagsParaListar?.length) {
            let other_filters = ''
            if(page_location?.includes('?')) {
                other_filters = page_location?.split('?')[1]
            }
            tagsParaListar?.forEach( addTag => {
                let tagsWithoutCurrent = arrayTags?.filter(t => t !== addTag)
                const newEndpointClick = special_collection + (tagsWithoutCurrent?.length ? `/${tagsWithoutCurrent?.join('+')}` : '') + (other_filters !== '' ? `?${other_filters}` : '')
                document.querySelector('ul.tag-list--active-tags')?.insertAdjacentHTML('beforeend', `
                    <li class="tag tag--remove custom-filter-active" data-value="${addTag}">
                        <a class="btn btn--small" href="${newEndpointClick}">
                            ${addTag}
                        </a>
                        <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-close" viewBox="0 0 64 64"><title>icon-X</title><path d="m19 17.61 27.12 27.13m0-27.12L19 44.74"></path></svg>
                    </li>
                `)
            })
        }
    }

    const numerFiltersPrev = document.querySelectorAll("#FilterDrawer .filter-form > div")
    const htmlFilters = `
        ${arrayFilters?.map((filter, index) => {
            const group = numerFiltersPrev?.length + index + 1
            return `
            <div class="collection-sidebar__group--${group}">
                <div class="collection-sidebar__group collection-sidebar__group--jm">
                    <button type="button" data-id="SidebarDrawer--custom-filter-${group}" class="collapsible-trigger--custom-filter collapsible-trigger collapsible-trigger-btn collapsible--auto-height tag-list__header" aria-expanded="false">
                        ${filter?.title}
                        <span class="collapsible-trigger__icon collapsible-trigger__icon--open" role="presentation">
                            <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon--wide icon-chevron-down" viewBox="0 0 28 16"><path d="m1.57 1.59 12.76 12.77L27.1 1.59" stroke-width="2" stroke="#000" fill="none"></path></svg>
                        </span>
                    </button>
                    <div id="SidebarDrawer--custom-filter-${group}" class="collapsible-content collapsible-content--sidebar">
                        <div class="collapsible-content__inner">
                            <ul class="no-bullets tag-list ">
                                ${filter?.options?.map( filterOption => {
                                    return `
                                    <li class="tag custom-filter-prod" data-value="ft:${handleize(filterOption)}">
                                        <label class="tag__checkbox-wrapper text-label">
                                            <span class="tag__checkbox"></span>
                                            <span>
                                                <span class="tag__text">
                                                    ${filterOption}
                                                </span>
                                            </span>
                                        </label>
                                    </li>
                                    `
                                })?.join('')}
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
            `
        })?.join('')}
    `
    filterFormDrawer?.insertAdjacentHTML("beforeend", htmlFilters)
    
    const collapsibleTriggerCustomFilter = document.querySelectorAll('.collapsible-trigger--custom-filter')
    collapsibleTriggerCustomFilter?.forEach( collapsibleButton => {
        collapsibleButton?.addEventListener('click', (e) => {
            e.preventDefault()
            if(collapsibleButton?.className?.includes('is-open')) {
                collapsibleButton?.classList?.remove('is-open')
                collapsibleButton?.setAttribute('aria-expanded', 'false')
                document.getElementById(collapsibleButton?.getAttribute('data-id'))?.classList?.remove('is-open')
            } else {
                collapsibleButton?.classList?.add('is-open')
                collapsibleButton?.setAttribute('aria-expanded', 'true')
                document.getElementById(collapsibleButton?.getAttribute('data-id'))?.classList?.add('is-open')
            }
        })
    })

    const customFilterProd = document.querySelectorAll('.custom-filter-prod')
    customFilterProd?.forEach(filterProd => {
        filterProd?.addEventListener('click', (e) => {
            e.preventDefault()
            const send_new_tag = filterProd?.getAttribute('data-value')
            if(send_new_tag?.trim() === '') return

            const current_location = window.location.href
            const current_pathname = window.location.pathname
            let current_tags = current_pathname?.replace(special_collection, '')
            current_tags = current_tags?.replace('/', '')?.trim()
            let new_tags = ''

            if(current_tags !== '') {
                new_tags = `${current_pathname}+${send_new_tag}`
            } else {
                new_tags = `${current_pathname}/${send_new_tag}`.replace('//', '/')
            }

            const new_full_url = current_location?.replace(current_pathname, new_tags)

            if (theme?.FilterDrawer) {
                theme.FilterDrawer.close()
            }

            window.location.href = new_full_url
        })
    })
}

window.onload = () => {
    evalPageCustom()
    evalCountryLoaded()
    configureAditionalTagFilters()
}